import React, { useEffect, useState, useContext } from 'react';
import { Handle } from 'react-flow-renderer';
import { FiTrash2, FiEdit } from 'react-icons/fi';

import { Tabs, Tab, ModalWrapper } from '../components';
import { types } from '../utils';

import { Form } from './Form';
import { ModalContext } from '@c/Constructor/Modal';

import styles from './style.module.scss';

const TextDefaultDemonstaration = ({ onDragStart = () => {} }) => {
    return (
        <div
            className={styles.container_demonstration}
            onDragStart={onDragStart}
            draggable
        >
            <p>Текст</p>
        </div>
    );
};

const TextWithTypesDemonstration = ({ onDragStart = () => {} }) => {
    return (
        <div
            className={styles.container_demonstration}
            onDragStart={onDragStart}
            draggable
        >
            <p>Текст (по типам восприятия)</p>
        </div>
    );
};

const Handles = ({ children }) => {
    return (
        <>
            <Handle
                type="target"
                position="left"
                id="in"
                className={styles.point_in}
            />
            {children}
            <Handle
                type="source"
                position="right"
                id="out"
                className={styles.point_out}
            />
        </>
    );
};

const defaultDataInitValue = {
    text: '',
    images: [],
    videos: [],
    audios: [],
    onChange: () => {},
    onRemove: () => {},
};

const dataByTypesInitValue = {
    audial: { ...defaultDataInitValue },
    visual: { ...defaultDataInitValue },
    kinesthetic: { ...defaultDataInitValue },
    discrete: { ...defaultDataInitValue },
    onChange: () => {},
    onRemove: () => {},
};

const TextDefault = ({ id, data }) => {
    const { show, close } = useContext(ModalContext);
    const [_data, setData] = useState({
        ...defaultDataInitValue,
        ...data,
    });

    useEffect(() => {
        _data.onChange(id, _data);
    }, [_data, id]);

    const editOpen = () => {
        show(
            <ModalWrapper onButtonClick={() => close()}>
                <Form
                    data={_data}
                    onChange={(val) => setData((prev) => ({ ...prev, ...val }))}
                />
            </ModalWrapper>
        );
    };

    return (
        <div className={styles.container}>
            <Handles>
                <FiTrash2
                    className={styles.icon}
                    onClick={() => data.onRemove(id)}
                    size={30}
                    color={'red'}
                />
                <FiEdit
                    className={styles.edit}
                    size={30}
                    color={'#3b82f6'}
                    onClick={() => editOpen()}
                />
                <p className={styles.header}>Текстовый блок</p>
                <p className={styles.description}>
                    {data.text &&
                        data.text.replace(/<[^>]+>/gm, '').slice(0, 200)}
                </p>
            </Handles>
        </div>
    );
};

const TextWithTypes = ({ id, data = {} }) => {
    const { show, close } = useContext(ModalContext);
    const [_data, setData] = useState({ ...dataByTypesInitValue, ...data });

    useEffect(() => {
        _data.onChange(id, _data);
    }, [_data, id]);

    const editOpen = () =>
        show(
            <ModalWrapper onButtonClick={() => close()}>
                <Tabs>
                    {Object.keys(types).map((key) => (
                        <Tab name={types[key]} key={key}>
                            <Form
                                data={{ ..._data[key] }}
                                onChange={(val) =>
                                    setData((prev) => ({
                                        ...prev,
                                        [key]: { ...prev[key], ...val },
                                    }))
                                }
                            />
                        </Tab>
                    ))}
                </Tabs>
            </ModalWrapper>
        );

    return (
        <div className={styles.container}>
            <Handles>
                <FiTrash2
                    className={styles.icon}
                    onClick={() => data.onRemove(id)}
                    size={30}
                    color={'red'}
                />
                <FiEdit
                    className={styles.edit}
                    size={30}
                    color={'#3b82f6'}
                    onClick={() => editOpen()}
                />
                <p className={styles.header}>
                    Текстовый блок (по типам восприятия)
                </p>
            </Handles>
        </div>
    );
};

export {
    TextWithTypes,
    TextWithTypesDemonstration,
    TextDefault,
    TextDefaultDemonstaration,
};
